module.exports = __webpack_public_path__ + "media/images/cv/screenshot_train_schedule-f10d478befbc4b2dcca2795bfacb240d.jpg";